<!--  -->
<template>
  <div class="account_box">

    <el-form
      :label-position="labelPosition"
      label-width="130px"
      :model="formLabelAlign"
    >
      <div class="formwr">
        <div class="book_boxr">
          <h2 style="margin-bottom:10px">公众号基础信息</h2>
          <el-form-item label="公众号名称">
            <el-autocomplete
              v-model="formLabelAlign.name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入公众号"
              @select="handleSelect"
            />
          </el-form-item>
          <el-form-item label="头像">
            <img
              :src="formLabelAlign.avater"
              alt=""
              style="width:100px;height:100px"
            >
          </el-form-item>
          <el-form-item label="app_id/gh_id">
            {{ formLabelAlign.appid }}/{{ formLabelAlign.ghid }}
          </el-form-item>
          <el-form-item label="状态">
            {{ formLabelAlign.status }}
          </el-form-item>
          <el-form-item label="认证信息">
            {{ formLabelAlign.veriypestr }}
          </el-form-item>
          <el-form-item label="主体名称">
            {{ formLabelAlign.zhuti }}
          </el-form-item>
          <el-form-item label="运营状态">
            <div style="display:flex">
              <div v-if="edit">
                <div v-if="valuetype == 1">
                  在跑
                </div>
                <div v-else-if="valuetype == 2">
                  停跑
                </div>
                <div v-else>
                  永封
                </div>
              </div>
              <div v-else>
                <el-select
                  v-model="value"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div style="margin-left:10px">
                <el-button
                  v-if="edit"
                  type="primary"
                  size="mini"
                  @click="edsw"
                >修改</el-button>
                <el-button
                  v-if="edit == false"
                  type="primary"
                  size="mini"
                  @click="edswxdca"
                >取消</el-button>
                <el-button
                  v-if="edit == false"
                  type="primary"
                  size="mini"
                  @click="deqawe"
                >确定</el-button>
              </div>
            </div>

          </el-form-item>

          <el-form-item label="备注">
            <div style="display:flex">
              <div v-if="remarktype">
                {{ linremark }}
              </div>
              <div v-else>
                <el-input
                  v-model="remark"
                  placeholder="请输入内容"
                />
              </div>
              <div style="margin-left:10px">
                <el-button
                  v-if="remarktype"
                  type="primary"
                  size="mini"
                  @click="edswone"
                >修改</el-button>
                <el-button
                  v-if="remarktype == false"
                  type="primary"
                  size="mini"
                  @click="edswxdcaone"
                >取消</el-button>
                <el-button
                  v-if="remarktype == false"
                  type="primary"
                  size="mini"
                  @click="deremark"
                >确定</el-button>
              </div>
            </div>

          </el-form-item>
        </div>
        <div class="book_box">
          <h2>书城信息</h2>
          <div class="sdewrw">
            <div>
              <el-form-item label="绑定平台">
                <div style="display:flex">
                  <div
                    v-if="bangpingtai"
                    style="width:50px"
                  >
                    {{ formLabelAlign.platformidtext }}
                  </div>
                  <div v-else>
                    <el-select
                      v-model="platformvalue"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in optionsr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </div>
                  <div style="margin-left:10px" class="search_box">
                    <el-button
                      v-if="bangpingtai"
                      size="mini"
                      type="primary"
                      @click="bangpingtaixiu"
                    >修改</el-button>
                    <el-button
                      v-if="bangpingtai == false"
                      size="mini"
                      type="primary"
                      @click="bangpingtaiqu"
                    >取消</el-button>
                    <el-button
                      v-if="bangpingtai == false"
                      size="mini"
                      type="primary"
                      @click="deqaweone"
                    >确定</el-button>
                  </div>
                </div>
              </el-form-item>
              <div style="margin-top:40px">
                <el-form-item label="是否基础号">
                  <div style="display:flex">
                    <div
                      v-if="baostatue"
                      style="width:50px"
                    >
                      <div v-if="basicaccount == 1">
                        否
                      </div>
                      <div v-if="basicaccount == 2">
                        是
                      </div>
                    </div>
                    <div v-else>
                      <el-select
                        v-model="baisrw"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in optionsse"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </div>

                    <div style="margin-left:10px" class="search_box">
                      <el-button
                        v-if="baostatue"
                        type="primary"
                        size="mini"
                        @click="baostatuexoi"
                      >修改</el-button>
                      <el-button
                        v-if="baostatue == false"
                        size="mini"
                        type="primary"
                        @click="baostatuexoiqixoa"
                      >取消</el-button>
                      <el-button
                        v-if="baostatue == false"
                        size="mini"
                        type="primary"
                        @click="deqawetwo"
                      >确定</el-button>
                    </div>
                  </div>

                </el-form-item>
              </div>
              <div
                v-if="leader == 1"
                style="margin-top:40px"
              >
                <el-form-item label="是否修改管理员">
                  <div style="display:flex">
                    <div>
                      <el-select
                        v-model="advalue"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in adoptions"
                          :key="item.admin_id"
                          :label="item.admin_name"
                          :value="item.admin_id"
                        />
                      </el-select>
                    </div>
                    <div style="margin-left:10px"><el-button
                      type="primary"
                      size="mini"
                      @click="adcontenrt"
                    >确定修改</el-button></div>
                  </div>

                </el-form-item>
              </div>

            </div>
            <div class="tips">
              <div style="color:#606266;font-size:14px">
                变更平台：
                1、所有客服消息将会暂停发送
                2、定时策略，群发策略将暂停推送
                3、所有策略将取消绑定
                4、用户信息将会全部重新获取。
              </div>
              <div
                class="tipsrw"
                style="color:#606266;font-size:14px"
              >
                什么是基础号：是初始化书城平台书籍信息，一个书城可以拥有多个基础号，不同号的不同书籍取并集
              </div>
              <div
                v-if="leader == 1"
                class="tipsrw"
                style="color:#606266;font-size:14px;padding-top:20px"
              >
                修改管理员该公众号当前绑定所有策略将失效
              </div>
            </div>

          </div>

        </div>
      </div>
      <div style="display: flex;align-items: center;">
        <div
          class="book_boxr"
          style="margin-top:10px;"
        >
          <h2 style="margin-bottom:10px">接口状态</h2>
          <el-form-item label="客服消息接口状态">
            {{ formLabelAlign.api_disabled_custom_text }}
            <el-button
              v-if="formLabelAlign.api_disabled_custom == 1"
              style="margin-left:10px"
              size="mini"
              type="primary"
              @click="relieve"
            >解除禁用</el-button>
          </el-form-item>
          <div class="Quota_box">
            <el-button
              size="mini"
              type="primary"
              @click.stop="clear"
            >清空Quota</el-button>
            <div style="margin-left:10px">本接口用于清空公众号/小程序/第三方平台等接口的每日调用接口次数（一个月仅支持10次，超过将不生效）</div>
          </div>
        </div>
        <div
          class="book_boxr"
          style="margin:10px 0px 0px 10px;width: 830px;"
        >
          <h2 style="margin-bottom:10px">填写预览openid <span style="font-size: 20px;">( 输入多个预览openid请用英文逗号','进行间隔 )</span></h2>
          <el-form-item
            label="openid"
            label-width="80px"
          >
            <el-input
              v-model="textarea"
              placeholder="请输入预览openid（请用英文逗号','进行间隔）"
              style="width: 700px;"
            />
          </el-form-item>
          <div class="Quota_box">
            <el-button
              size="mini"
              type="primary"
              @click.stop="sumbirtr"
            >保存</el-button>
          </div>
        </div>
      </div>
      <div
        class="book_boxr"
        style="margin:10px 0px 0px 0px;width: 830px;"
      >
        <h2 style="margin-bottom:10px">公众号绑定的书城小程序appid</h2>
        <el-form-item
          label="小程序appid"
          label-width="100px"
        >
          <el-input
            v-model="book_mini_program_app_id"
            placeholder="请输入appid"
            style="width: 700px;"
          />
        </el-form-item>
        <div class="Quota_box">
          <el-button
            size="mini"
            type="primary"
            @click.stop="sumbitbook"
          >保存</el-button>
        </div>
      </div>

    </el-form>
  </div>
</template>

<script>
import { officialAccountlistinfo, strategyPlatform, updatestatuswe, getadminlist, changeAdminupdata, accountrelieveupdata, accountclearQuota, officialAccountupdateRemark, officialAccountupdateBookMiniProgramAppld } from '@/api/sourceMaterial.js'
import { officialAccountSearchDisplay } from '@/api/effectData.js'
import { previewOpenidUpdate } from '@/api/bserw.js'
import { mapGetters } from 'vuex'
export default {
  components: {},

  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        avater: '',
        appid: '',
        ghid: '',
        status: '',
        veriypestr: '',
        zhuti: '',
        platformidtext: '',
        api_disabled_custom: null,
        api_disabled_custom_text: ''
      },
      platformvalue: null,
      platformvaluebeiyong: null,
      query: {
        // page: 1,
        // pageSize: 10,
        app_id: null
        // onlyMe: null
      },
      bangpingtai: true,
      options: [
        {
          value: 1,
          label: '在跑'
        },
        {
          value: 2,
          label: '停跑'
        },
        {
          value: 3,
          label: '永封'
        }
      ],
      optionsse: [
        {
          value: 1,
          label: '否'
        },
        {
          value: 2,
          label: '是'
        }
      ],
      optionsr: [],
      adoptions: [],
      advalue: null,
      edit: true,
      value: null,
      valuetype: null,

      basicaccount: null,
      baisrw: null,

      baostatue: true,
      appid: null,
      textarea: '',
      remarktype: true,
      linremark: '',
      remark: '',
      book_mini_program_app_id: ''
    }
  },
  computed: {
    ...mapGetters(['leader'])
  },
  async created() {
    this.query.app_id = this.$route.query.appId
    // this.query.onlyMe = this.$route.query.onlyMe
    console.log('this.$route.query', this.$route.query)
    this.getofflist()
    this.getPlatform()
    console.log(this.leader)
    // eslint-disable-next-line eqeqeq
    if (this.leader == 1) {
      this.adminlist()
    }
    const data = await officialAccountSearchDisplay({
      appId: this.$route.query.appId
    })
    // data.data.list = data.data.list
    this.formLabelAlign.name = data.data.list[0].account_name
  },
  mounted() {
    // this.handleSelect({ app_id: this.formLabelAlign.name })
  },
  methods: {
    async adminlist() {
      const data = await getadminlist()
      this.adoptions = data.data.list
      console.log('data', data)
    },
    // 获取平台
    async getPlatform() {
      const data = await strategyPlatform()
      this.optionsr = data.data.list
    },
    async getofflist() {
      const data = await officialAccountlistinfo(this.query)
      console.log('data', data.data.detail)
      this.formLabelAlign.name = data.data.detail.account_name
      this.formLabelAlign.avater = data.data.detail.head_img
      this.formLabelAlign.appid = data.data.detail.app_id
      this.formLabelAlign.ghid = data.data.detail.gh_id
      this.formLabelAlign.status = data.data.detail.status_str
      this.formLabelAlign.veriypestr = data.data.detail.verify_type_str
      this.formLabelAlign.zhuti = data.data.detail.principal_name
      this.formLabelAlign.api_disabled_custom = data.data.detail.api_disabled_custom
      this.formLabelAlign.api_disabled_custom_text = data.data.detail.api_disabled_custom_text
      this.value = data.data.detail.operation_status
      this.valuetype = data.data.detail.operation_status

      this.formLabelAlign.platformidtext = data.data.detail.platform_id_text

      this.platformvalue = data.data.detail.platform_id
      this.platformvaluebeiyong = data.data.detail.platform_id

      this.basicaccount = data.data.detail.basic_account
      this.baisrw = data.data.detail.basic_account

      this.appid = data.data.detail.app_id
      this.advalue = Number(data.data.detail.admin_id)

      this.textarea = data.data.detail.open_ids

      this.linremark = data.data.detail.remark

      this.book_mini_program_app_id = data.data.detail.book_mini_program_app_id
    },
    edsw() {
      this.edit = !this.edit
    },
    edswone() {
      this.remarktype = !this.remarktype
      this.remark = this.linremark
    },
    edswxdca() {
      this.edit = !this.edit
      this.value = this.valuetype
    },
    edswxdcaone() {
      this.remarktype = !this.remarktype
      this.remark = ''
    },
    bangpingtaixiu() {
      this.bangpingtai = !this.bangpingtai
    },
    bangpingtaiqu() {
      this.bangpingtai = !this.bangpingtai
      this.platformvalue = this.platformvaluebeiyong
    },
    baostatuexoi() {
      this.baostatue = !this.baostatue
    },
    baostatuexoiqixoa() {
      this.baostatue = !this.baostatue
      this.baisrw = this.basicaccount
    },
    deqawe() {
      this.$confirm('确定修改此运营状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          updatestatuswe({
            app_id: this.appid,
            type: 2,
            content: this.value
          }).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.edit = true
            this.getofflist()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    deremark() {
      this.$confirm('确定修改此备注, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          officialAccountupdateRemark({
            app_id: this.appid,
            remark: this.remark
          }).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.remarktype = true
            this.getofflist()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    deqaweone() {
      this.$confirm('确定修改此绑定平台, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          updatestatuswe({
            app_id: this.appid,
            type: 1,
            content: this.platformvalue
          }).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.bangpingtai = true
            this.getofflist()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    deqawetwo() {
      this.$confirm('确定修改此基础号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          updatestatuswe({
            app_id: this.appid,
            type: 3,
            content: this.baisrw
          })
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.baostatue = true
          this.getofflist()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    relieve() {
      this.$confirm('确定解除禁用吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          accountrelieveupdata({
            app_id: this.appid
          })
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getofflist()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    async adcontenrt() {
      const data = await changeAdminupdata({
        app_id: this.appid,
        admin_id: this.advalue
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      console.log('data', data)
    },
    clear() {
      this.$confirm('确定清空吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          accountclearQuota({
            app_id: this.appid
          }).then(res => {
            console.log('res', res.code)
            // eslint-disable-next-line eqeqeq
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '清空成功'
              })
              this.getofflist()
            }
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    async sumbirtr() {
      try {
        const data = await previewOpenidUpdate({
          app_id: this.query.app_id,
          open_ids: this.textarea
        })
        // this.textarea = ''
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
        console.log('data', data)
      } catch {
        // this.textarea = ''
        console.log('err')
      }
    },
    async sumbitbook() {
      try {
        if (this.book_mini_program_app_id === '') {
          this.$message({
            type: 'error',
            message: '请输入公众号绑定的书城小程序appid'
          })
          return
        }
        const data = await officialAccountupdateBookMiniProgramAppld({
          app_id: this.query.app_id,
          book_mini_program_app_id: this.book_mini_program_app_id
        })
        // this.textarea = ''
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
        this.$router.push({
          path: '/accountList/officialaccountList'
        })
        console.log('data', data)
      } catch {
        // this.textarea = ''
        console.log('err')
      }
    },
    async querySearchAsync(queryString, cb) {
      const data = await officialAccountSearchDisplay({ accountName: queryString })
      const list = data.data.list
      list.forEach(item => {
        item.value = item.account_name
        item.address = item.app_id
      })
      cb(list)
    },
    async handleSelect(item) {
      console.log('item', item)
      this.query.app_id = item.app_id
      this.getofflist()
      // const data = await fanStatistics({ appId: this.formLabelAlign.appid })
      // this.keyindicators = data.data
      // this.allappid = item.app_id
      // this.empty()
      // this.query()
      // this.localEchart()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.account_box {
  padding: 20px;
}
.formwr {
  display: flex;
}
.book_boxr {
  border: 1px solid #409eff;
  width: 500px;
  padding-left: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  padding-bottom: 20px;
}
.book_box {
  border: 1px solid #409eff;
  width: 1000px;
  margin-left: 100px;
  border-radius: 10px;
  padding-left: 30px;
}
.sdewrw {
  display: flex;
}
.tips {
  margin-left: 100px;
  width: 400px;
}
.tipsrw {
  margin-top: 30px;
}
.Quota_box {
  display: flex;
  align-items: center;
  font-size: 14px;
}
@media (max-width: 768px){
  .book_boxr{
    width:auto;
    box-sizing:border-box;
    border:none;
    border-radius:0px;
    border-bottom:1px solid #165DFF;
  }
  .formwr{
    flex-direction: column;
  }
  .el-form-item--medium .el-form-item__content{
    font-size:3vw;
  }
  .book_box{
    margin:0px;
    padding:0px;
    border:none;
    border-radius:0px;
    border-bottom:1px solid #165DFF;
  }
  .el-select{
    width:60%;
  }
  .el-form-item {
    margin-bottom: 22px;
    display: flex;
    align-items: flex-start;
  }
}
</style>
